module.exports = __webpack_public_path__ + "media/icons/inne_uslugi@3x-79be181f.svg";